<div
  class="ui-tree"
  [class.ui-tree--loading]="loading()"
  role="tree"
  aria-label="Árbol de navegación"
>
  <!-- Filtro opcional -->
  @if (showFilter()) {
    <div class="ui-tree__filter">
      <span class="ui-tree__filter-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
      </span>
      <input
        type="text"
        class="ui-tree__filter-input"
        [placeholder]="filterPlaceholder()"
        [value]="filterQuery()"
        (input)="onFilterInput($event)"
        aria-label="Filtrar árbol"
      />
    </div>
  }

  <!-- Estado: cargando -->
  @if (loading()) {
    <div class="ui-tree__loading" role="status">
      <span class="ui-tree__loading-spinner"></span>
      <span>Cargando...</span>
    </div>

  <!-- Estado: sin nodos -->
  } @else if (!visibleNodes().length) {
    <p class="ui-tree__empty">{{ emptyMessage() }}</p>

  <!-- Nodos raíz -->
  } @else {
    <ul class="ui-tree__list" role="group">
      @for (node of visibleNodes(); track node.key) {
        <ng-container
          [ngTemplateOutlet]="nodeTemplate"
          [ngTemplateOutletContext]="{ node: node, depth: 0 }"
        />
      }
    </ul>
  }
</div>

<!-- Template recursivo de nodo -->
<ng-template #nodeTemplate let-node="node" let-depth="depth">
  <li
    class="ui-tree__item"
    [class.ui-tree__item--selected]="isSelected(node.key)"
    [class.ui-tree__item--disabled]="node.disabled"
    [class.ui-tree__item--leaf]="!hasChildren(node)"
    role="treeitem"
    [attr.aria-expanded]="hasChildren(node) ? isExpanded(node.key) : null"
    [attr.aria-selected]="selectionMode() !== 'none' ? isSelected(node.key) : null"
    [attr.aria-disabled]="node.disabled || null"
  >
    <!-- Fila completa del nodo: click en cualquier punto expande/colapsa y selecciona -->
    <div
      class="ui-tree__node"
      [style.--tree-depth]="depth"
      (click)="onNodeRowClick(node)"
      (keydown.enter)="onNodeRowClick(node)"
      (keydown.space)="$event.preventDefault(); onNodeRowClick(node)"
      [attr.tabindex]="node.disabled ? -1 : 0"
    >
      <!-- Checkbox (solo en modo checkbox) -->
      @if (selectionMode() === 'checkbox') {
        <span
          class="ui-tree__checkbox"
          [class.ui-tree__checkbox--checked]="isSelected(node.key)"
          aria-hidden="true"
        >
          @if (isSelected(node.key)) {
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M1.5 5L4 7.5L8.5 2.5" stroke="white" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
        </span>
      }

      <!-- Indicador de expand/collapse (puramente visual, la interacción la maneja la fila) -->
      <span
        class="ui-tree__toggle"
        [class.ui-tree__toggle--expanded]="isExpanded(node.key)"
        [class.ui-tree__toggle--hidden]="!hasChildren(node)"
        aria-hidden="true"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </span>

      <!-- Icono del nodo (visible según showIcons e iconLevels) -->
      @if (shouldShowIcon(node, depth)) {
        <span class="ui-tree__icon" aria-hidden="true">{{ node.icon }}</span>
      }

      <!-- Label -->
      <span class="ui-tree__label">{{ node.label }}</span>

      @if (nodeActionsTemplate(); as actionsTpl) {
        <div
          class="ui-tree__actions"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        >
          <ng-container
            [ngTemplateOutlet]="actionsTpl"
            [ngTemplateOutletContext]="{ $implicit: node }"
          />
        </div>
      }
    </div>

    <!-- Hijos (recursión via ngTemplateOutlet) -->
    @if (hasChildren(node) && isExpanded(node.key)) {
      <ul class="ui-tree__children" role="group">
        @for (child of node.children; track child.key) {
          <ng-container
            [ngTemplateOutlet]="nodeTemplate"
            [ngTemplateOutletContext]="{ node: child, depth: depth + 1 }"
          />
        }
      </ul>
    }
  </li>
</ng-template>
